import { ReactElement } from 'react';
import { AddToCompareAction } from '@client/product/components/ProductActions/AddToCompareAction';
import classNames from 'classnames';
import { CHECKBOX_BUTTON_SIZE } from 'b2b-components/core/components/Form/Checkbox/CheckboxButton';
import { ADD_TO_WISHLIST_STYLE_TYPE, AddToWishlistAction } from './AddToWishlistAction';
import { PDFAction } from './PDFAction';
import { Props } from './';
import './ProductActions.scss';

export const ProductActions = ({ className, product }: Props): ReactElement => (
  <div className={classNames('ProductActions', className)}>
    <AddToCompareAction
      className='ProductAction--Hide'
      product={product}
      buttonSize={CHECKBOX_BUTTON_SIZE.default}
    />
    <AddToWishlistAction skus={[product.sku]} styleType={ADD_TO_WISHLIST_STYLE_TYPE.full} />
    <PDFAction product={product} />
  </div>
);
